import Component from '@glimmer/component';
import type { FilterItem } from 'garaje/models/common';

interface OutcomeFilterArgs {
  options: FilterItem[];
  selected: string[];
  onSelect: (outcomes: string[]) => void;
}

export default class OutcomeFilter extends Component<OutcomeFilterArgs> {
  get selectedOptions(): FilterItem[] {
    return this.args.options.filter((opt) => this.args.selected.includes(opt.filter));
  }

  get displayText(): string {
    if (this.args.selected.length === 0) {
      return 'All outcomes';
    }
    if (this.args.selected.length === 1) {
      return this.selectedOptions[0]?.name || 'All outcomes';
    }
    return `${this.args.selected.length} outcomes`;
  }
}
